module.exports = __webpack_public_path__ + "static/humanitarian_card_img5@2x-e830332e74b5d5d5f98e65ced045fa3c.jpg";